import { getLang } from "app/feature/constants";

export const luckyDrawCreated = ({
  hasLuckyDrawEditAccessRight,
  id,
  disableViewParticipant,
  progress,
  handleView,
  handleViewParticipants,
  handleViewPrize,
  lang,
  canEditName,
  canEditDesc,
  canEditPeriod,
  canEditAssignProduct,
  canEditImage,
  canEditTnc,
  canEditForm,
  canSetPrize,
  canReadPrize,
  canWritePrize,
  canDeletePrize,
  canSetWinner,
  canReadWinner,
  canWriteWinner,
}) => {
  let actionItems = []
  actionItems.push({
    label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_DETAIL") : getLang(lang,"label.VIEW_DETAIL"),
    action: () => handleView(id)
  })
  actionItems.push({
    label: getLang(lang,"label.SET_PRIZE"),
    action: () => handleViewPrize(id, progress),
    disabled: canSetPrize,
  })
  actionItems.push({
    label: getLang(lang,"label.VIEW_PARTICIPANTS"),
    action: () => handleViewParticipants(id),
    disabled: disableViewParticipant,
  })
  actionItems.push({
    label: getLang(lang,"label.DOWNLOAD_WINNER_LIST"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  actionItems.push({
    label: getLang(lang,"label.LIVE_DRAW"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  return actionItems
};

export const prizeCreated = ({
  hasLuckyDrawEditAccessRight,
  id,
  disableViewParticipant,
  progress,
  handleView,
  handleViewParticipants,
  handleViewPrize,
  handleViewWinner,
  lang,
  canEditName,
  canEditDesc,
  canEditPeriod,
  canEditAssignProduct,
  canEditImage,
  canEditTnc,
  canEditForm,
  canSetPrize,
  canReadPrize,
  canWritePrize,
  canDeletePrize,
  canSetWinner,
  canReadWinner,
  canWriteWinner,
}) => {
  let actionItems = []
  actionItems.push({
    label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_DETAIL") : getLang(lang,"label.VIEW_DETAIL"),
    action: () => handleView(id)
  })
  actionItems.push({
    label: canWritePrize ? getLang(lang,"label.VIEW_EDIT_PRIZE") : getLang(lang,"label.VIEW_PRIZE"),
    action: () => handleViewPrize(id, progress),
    disabled: !canSetPrize,
  })
  actionItems.push({
    label: getLang(lang,"label.SET_WINNER"),
    action: () => handleViewWinner(id, progress),
    disabled: !canSetWinner,
  })
  actionItems.push({
    label: getLang(lang,"label.VIEW_PARTICIPANTS"),
    action: () => handleViewParticipants(id),
    disabled: disableViewParticipant,
  },)
  actionItems.push({
    label: getLang(lang,"label.DOWNLOAD_WINNER_LIST"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  actionItems.push({
    label: getLang(lang,"label.LIVE_DRAW"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  return actionItems
};

export const winnerCreated = ({
  hasLuckyDrawEditAccessRight,
  id,
  disableViewParticipant,
  progress,
  handleView,
  handleViewParticipants,
  handleViewPrize,
  handleViewWinner,
  lang,
  canEditName,
  canEditDesc,
  canEditPeriod,
  canEditAssignProduct,
  canEditImage,
  canEditTnc,
  canEditForm,
  canSetPrize,
  canReadPrize,
  canWritePrize,
  canDeletePrize,
  canSetWinner,
  canReadWinner,
  canWriteWinner,
}) => {
  let actionItems = []
  actionItems.push({
    label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_DETAIL") : getLang(lang,"label.VIEW_DETAIL"),
    action: () => handleView(id)
  })
  actionItems.push({
    label: canWritePrize ? getLang(lang,"label.VIEW_EDIT_PRIZE") : getLang(lang,"label.VIEW_PRIZE"),
    action: () => handleViewPrize(id, progress),
    disabled: !canReadPrize,
  })
  actionItems.push({
    label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_WINNER") : getLang(lang,"label.VIEW_WINNER"),
    action: () => handleViewWinner(id, progress),
    disabled: !canReadWinner,
  })
  actionItems.push({
    label: getLang(lang,"label.VIEW_PARTICIPANTS"),
    action: () => handleViewParticipants(id),
    disabled: disableViewParticipant,
  },)
  actionItems.push({
    label: getLang(lang,"label.DOWNLOAD_WINNER_LIST"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  actionItems.push({
    label: getLang(lang,"label.LIVE_DRAW"),
    disabled: true,
    required: true,
    requiredText: getLang(lang,"label.REQUIRED_CONFIRM_WINNER")
  })
  return actionItems
};

export const winnerConfirm = ({
  hasLuckyDrawEditAccessRight,
  id,
  disableViewParticipant,
  progress,
  luckyDrawTitle,
  handleView,
  handleViewParticipants,
  handleViewPrize,
  handleViewWinner,
  handleLiveDraw,
  handleDownloadWinner,
  lang,
  canEditName,
  canEditDesc,
  canEditPeriod,
  canEditAssignProduct,
  canEditImage,
  canEditTnc,
  canEditForm,
  canSetPrize,
  canReadPrize,
  canWritePrize,
  canDeletePrize,
  canSetWinner,
  canReadWinner,
  canWriteWinner,
  canStartLiveDraw,
}) => {
  return [
    {
      label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_DETAIL") : getLang(lang,"label.VIEW_DETAIL"),
      action: () => handleView(id)
    },
    {
      label: canWritePrize ? getLang(lang,"label.VIEW_EDIT_PRIZE") : getLang(lang,"label.VIEW_PRIZE"),
      action: () => handleViewPrize(id, progress),
      disabled: !canReadPrize,
    },
    {
      label: hasLuckyDrawEditAccessRight ? getLang(lang,"label.VIEW_EDIT_WINNER") : getLang(lang,"label.VIEW_WINNER"),
      action: () => handleViewWinner(id, progress),
      disabled: !canReadWinner,
    },
    {
      label: getLang(lang,"label.VIEW_PARTICIPANTS"),
      action: () => handleViewParticipants(id),
      disabled: disableViewParticipant,
    },
    {
      label: getLang(lang,"label.DOWNLOAD_WINNER_LIST"),
      action: () => handleDownloadWinner(id),
      disabled: !canWriteWinner,
    },
    {
      label: getLang(lang,"label.LIVE_DRAW"),
      action: () => handleLiveDraw(id, progress, luckyDrawTitle),
      disabled: !canStartLiveDraw,
    }
  ];
};

export const live = ({
  hasLuckyDrawEditAccessRight,
  id,
  disableViewParticipant,
  progress,
  luckyDrawTitle,
  handleView,
  handleViewParticipants,
  handleViewPrize,
  handleViewWinner,
  handleLiveDraw,
  handleDownloadWinner,
  lang,
  canEditName,
  canEditDesc,
  canEditPeriod,
  canEditAssignProduct,
  canEditImage,
  canEditTnc,
  canEditForm,
  canSetPrize,
  canReadPrize,
  canWritePrize,
  canDeletePrize,
  canSetWinner,
  canReadWinner,
  canWriteWinner,
  canStartLiveDraw,
}) => {
  return [
    {
      label: getLang(lang,"label.VIEW_DETAIL"),
      action: () => handleView(id)
    },
    {
      label: getLang(lang,"label.VIEW_PRIZE"),
      action: () => handleViewPrize(id, progress),
      disabled: !canSetPrize,
    },
    {
      label: getLang(lang,"label.VIEW_WINNER"),
      action: () => handleViewWinner(id, progress),
      disabled: !canSetWinner,
    },
    {
      label: getLang(lang,"label.DOWNLOAD_WINNER_LIST"),
      action: () => handleDownloadWinner(id),
      disabled: !canSetWinner,
    },
    {
      label: getLang(lang,"label.LIVE_DRAW"),
      action: () => handleLiveDraw(id, progress, luckyDrawTitle),
      disabled: !canStartLiveDraw,
    },
    {
      label: getLang(lang,"label.VIEW_PARTICIPANTS"),
      action: () => handleViewParticipants(id),
      disabled: disableViewParticipant,
    }
  ];
};
